import { Outlet } from "react-router";
import { ImpersonationBanner } from "./Layout/ImpersonationBanner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <ImpersonationBanner />
      <Outlet />
    </div>
  );
}
